// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { DividerTokens } from './type';

const dividerTokens: DividerTokens = {
  dividerFontSize: '12/regular',
  dividerFontColor: 'Neutral-text-5',
  dividerBorderColor: 'Neutral-border-1',
  dividerBorderWidth: 'Border-1',
  dividerHorizontalMarginY: 'Margin-24',
  dividerHorizontalTextMarginY: 'Margin-16',
  dividerVerticalMarginX: 'Margin-12',
  dividerTextPaddingX: '1em',
};

export default dividerTokens;
